<template>
	<div class="StaticEntry" :class="{ 'StaticEntry--sectionHeader': entry.style === 'section-header' }"
        :data-entries-section="entry.style === 'section-header' ? entry.key : null">
		<h2 class="u-secondHeading">{{entry.title}}</h2>
		<slot />
	</div>
</template>

<script>
	export default {
		props: {
			entry: Object
		}
	}
</script>

<style lang="scss" scoped>
	.StaticEntry {
		border-bottom: 2px solid var(--colorBrand);
		margin-bottom: 3em;
		padding-bottom: 3em;

		&:last-child {
			border-bottom: none;
		}

        &--sectionHeader {
            border-bottom: 0;
            padding-bottom: 0;
            margin-bottom: 2em;

            &:not(:first-child) {
                border-top: 2px solid var(--colorBrand);
                padding-top: 3em;
                margin-top: 3em;
            }
        }

		h2 {
			margin: 0 0 .8em;
			/*counter-increment: section;

			&:before {
				content: counter(section) '. ';
			}*/
		}
	}
</style>